import { actionTypes } from "./gameTypes"
export const setChoice = (choice)=>{
    return({
        type : actionTypes.SELECT_GAME_CHOICE,
        payload : choice
    })
}


export const setComputerChoice = ()=>{
    return({
        type : actionTypes.SELECT_COMPUTER_CHOICE,
        payload : Math.floor(Math.random()*3)
    })
}


export const resultDesicide = (result)=>{
    return({
        type : actionTypes.RESULT_DECICION,
        payload : result
    })
}

export const scoreComputation = (result)=>{
    let res
    if(result==="win"){
         res = 1
    }else if(result==="lose"){
        res = -1
    }else{
         res= 0
    }
    return({
        type : actionTypes.SCORE_COMPUTAION,
        payload : res
    })
}

export const flushState = ()=>{
    return ({
        type : actionTypes.FLUSH_STATE
    })
}